import type { SVGProps } from 'react';

// Geometry from the repository's logo3.svg. currentColor lets the surrounding
// theme supply the mark's color, including user-selected light/dark palettes.
export function CordeLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="none"
      stroke="currentColor"
      strokeWidth="28"
      strokeLinecap="round"
      aria-hidden="true"
      {...props}
    >
      <circle cx="256" cy="256" r="160" />
      <path d="M224 64v384M288 64v384M64 224h384M64 288h384" />
    </svg>
  );
}
